
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 25H2.333C1.6 25 1 24.4 1 23.667V2.333C1 1.6 1.6 1 2.333 1H19.12c.347 0 .693.147.933.387l4.56 4.56c.24.24.387.586.387.933V13","stroke":"#221B38","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M24.4 17.8l-3.307 5.72L21 25l1.24-.814 3.293-5.72-1.134-.666z","stroke":"#221B38","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M17 19.667H6.333M6.333 13h13.333M6.333 6.333H13M18.333 1v6.667H25V6.88c0-.347-.147-.693-.387-.933l-4.56-4.56A1.345 1.345 0 0019.12 1h-.787z","stroke":"#221B38","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    